function followPost(postIdSlug: string) {
  const { openAPIFetchOnce } = useAuthFetch()
  const path = '/napis/v1/discussion/follow-post/{post_id_slug}/'
  const method = 'post'
  const param = {
    post_id_slug: postIdSlug
  }
  const query = undefined

  return openAPIFetchOnce(path, method, param, query)
}

function unfollowPost(postIdSlug: string) {
  const { openAPIFetchOnce } = useAuthFetch()
  const path = '/napis/v1/discussion/follow-post/{post_id_slug}/'
  const method = 'delete'
  const param = {
    post_id_slug: postIdSlug
  }
  const query = undefined

  return openAPIFetchOnce(path, method, param, query)
}

type useForumFollowedPostReturnType = {
  followPost: typeof followPost
  unfollowPost: typeof unfollowPost
}

export function useForumFollowedPost(): useForumFollowedPostReturnType {
  return {
    followPost,
    unfollowPost
  }
}
